// extracted by mini-css-extract-plugin
export var typingIndicator = "_hx-0";